<!--
File: fascicle-list.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 3rd December 2024 4:42:16 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<p-progressBar mode="indeterminate" *ngIf="loading == false"></p-progressBar>

<div class="table-fascicles-container">
  <p-table
    [value]="dataSource"
    [reorderableColumns]="true"
    (onRowReorder)="changeFascicleOrder($event)"
    styleClass="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th>{{ 'FASCICLE.NAME' | translate }}</th>
        <th>{{ 'FASCICLE.PAGES' | translate }}</th>
        <th>{{ 'FASCICLE.STATUS' | translate }}</th>
        <th style="width: 10rem">{{ 'FORM.ACTIONS' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-fascicle let-index="rowIndex">
      <tr
        [pReorderableRow]="index"
        (mouseenter)="handleMouseOver(fascicle)"
        (mouseleave)="handleMouseLeave(fascicle)"
      >
        <!-- Drag handle -->
        <td>
          <span class="pi pi-bars" pReorderableRowHandle style="cursor: grab;"></span>
        </td>

        <!-- Nombre -->
        <td>{{ fascicle.name }}</td>

        <!-- Páginas -->
        <td>{{ showFromTo(fascicle) }}</td>

        <!-- Estado de bloqueo -->
        <td>
          <app-fascicle-block-status
            [fascicle]="fascicle"
            [currentUserId]="currentUserId"
            (requestUnblock)="onRequestUnblock($event)"
            (forceUnblock)="onForceUnblock($event)"
          ></app-fascicle-block-status>
        </td>

        <!-- Acciones -->
        <td>
          <div
            [id]="'actions-row-' + fascicle.id"
            class="actions-translucent flex gap-1"
          >
            <button
              pButton
              icon="pi pi-cog"
              class="p-button-rounded p-button-text p-button-sm"
              [pTooltip]="'FASCICLE.SETTINGS' | translate"
              (click)="openFascicleSettings(fascicle.id)"
            ></button>
            <button
              pButton
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text p-button-sm"
              [pTooltip]="'FORM.EDIT' | translate"
              (click)="editFascicle(fascicle.id)"
            ></button>
            <button
              pButton
              icon="pi pi-copy"
              class="p-button-rounded p-button-text p-button-sm"
              [pTooltip]="'FORM.CLONE' | translate"
              (click)="clone(fascicle.id)"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">{{ 'FASCICLE.NO_FASCICLES' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
